var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.styles.asset},[_c('img',{attrs:{"src":_vm.generateURL(_vm.file),"width":"40","height":"40"}}),_c('span',{staticClass:"flex-grow fs-12 fw-500"},[_vm._v(_vm._s(_vm.file.name))]),_c('i',{staticClass:"nexd-icon-32-delete",attrs:{"aria-hidden":"true"},on:{"click":function($event){return _vm.$emit('remove')}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }